import { Truck, CreditCard, ShieldCheck } from "@phosphor-icons/react";
import { Reveal, Overline } from "./Reveal";

const STEPS = [
    {
        icon: Truck,
        title: "Penghantaran Seluruh Malaysia",
        body: "Kami guna lori & penghantar khas untuk pastikan astana tiba dengan selamat — Semenanjung, Sabah & Sarawak.",
    },
    {
        icon: CreditCard,
        title: "Deposit Untuk Tempahan",
        body: "Deposit dikenakan bagi mengesahkan tempahan & persediaan pengangkutan. Baki dijelaskan sebelum penghantaran.",
    },
    {
        icon: ShieldCheck,
        title: "Selamat & Telus",
        body: "Setiap proses dimaklumkan dengan jelas. Resit & pengesahan diberikan pada setiap peringkat tempahan.",
    },
];

export const Shipping = () => (
    <section
        id="penghantaran"
        data-testid="shipping"
        className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36"
    >
        <div className="grid lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
                <Reveal>
                    <Overline>Penghantaran &amp; Pembayaran</Overline>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.02]">
                        Telus dari mula hingga pintu rumah.
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-6 text-ink-soft leading-relaxed max-w-md">
                        Kami percaya proses yang jelas membina kepercayaan. Inilah cara
                        astana anda sampai dengan selamat.
                    </p>
                </Reveal>
            </div>

            <div className="lg:col-span-7 flex flex-col divide-y divide-border border-t border-b border-border">
                {STEPS.map((s, i) => (
                    <Reveal key={s.title} delay={i * 0.1}>
                        <div className="group flex items-start gap-6 py-8">
                            <div className="shrink-0 flex h-14 w-14 items-center justify-center border border-border text-accent group-hover:bg-accent group-hover:text-white transition-colors duration-500">
                                <s.icon size={26} weight="light" />
                            </div>
                            <div>
                                <h3 className="font-display text-2xl text-ink tracking-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-ink-soft leading-relaxed">{s.body}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
